import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeaturePermissionsSandbox } from '@app/feature-scope/sandboxes/feature-permissions.sandbox';
import { HeaderService } from '@app/header/services/header.service';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { Checked } from '@app/ui/components/checked/checked.enum';
import { Observable } from 'rxjs';
import { menuItems } from './settings-details-menu.constants';
import { FeatureScope, FeatureScopeSandbox } from '@smooved/core';
import { MenuModule } from '@ui/menu';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CheckedComponent } from '@app/ui/components/checked/checked.component';

@Component({
    selector: 'app-settings-details-menu',
    template: `
        <div class="u-padding-x-axis-half">
            <app-menu>
                @for (item of items; track trackByFeatureScope) {
                    <app-menu-item
                        [goTo]="item.goTo"
                        [class.u-display-none]="item.hide && !(featureScopeSandbox.hasAccess(item.hide) | async)"
                        (click)="onMenuClick()"
                        appearance="button"
                        size="sm"
                    >
                        <div class="u-flex-row u-flex-align-items-center">
                            <app-checked
                                [checked]="(featureGranted$(item.featureScope) | async) ? checked.Ok : checked.Nok"
                                class="u-margin-right u-flex"
                            ></app-checked>
                            <span>{{ item.labelResource | translate }}</span>
                        </div>
                    </app-menu-item>
                }
            </app-menu>
        </div>
    `,
    styles: [':host {display: block; padding: 1rem;}'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MenuModule, AsyncPipe, TranslateModule, CheckedComponent],
})
export class SettingsDetailsMenuComponent {
    public checked = Checked;
    public items = Array.from(menuItems.values());
    public navigation = Navigation;
    public featureScope = FeatureScope;

    constructor(
        public readonly featureScopeSandbox: FeatureScopeSandbox,
        private readonly featurePermissionsSandbox: FeaturePermissionsSandbox,
        private readonly headerService: HeaderService,
    ) {}

    public featureGranted$(featureScope: FeatureScope): Observable<boolean> {
        return this.featurePermissionsSandbox.featureGranted$(featureScope);
    }

    public trackByFeatureScope(index: Number, featureScope: FeatureScope): string {
        return featureScope;
    }

    public onMenuClick(): void {
        this.headerService.dispatch();
    }
}
